$(function(){
	$("body").on("click", ".popupbutton .primary-button, .supportstrip .popup", function(evt) {
		evt.preventDefault();
		$this = $(this);
		window.open($this.attr('href'),'_blank','width='+$this.data('width')+',height='+$this.data('height')+',toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes');
	});
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/popuplink.js
// module id = 336
// module chunks = 0